import React from 'react';

import { SVGComponentProps } from './svg.types';

const MasterIconSVG = ({ size = '1em', wrapperClass, ...otherProps }: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <mask id="path-1-inside-1" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 14C48 6.26801 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26C0 39.2548 10.7452 50 24 50C37.2548 50 48 39.2548 48 26V14Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 14C48 6.26801 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26C0 39.2548 10.7452 50 24 50C37.2548 50 48 39.2548 48 26V14Z"
          fill="#FFF3E5"
        />
        <path
          d="M14 3H34V-3H14V3ZM3 26V14H-3V26H3ZM24 47C12.402 47 3 37.598 3 26H-3C-3 40.9117 9.08831 53 24 53V47ZM45 26C45 37.598 35.598 47 24 47V53C38.9117 53 51 40.9117 51 26H45ZM45 14V26H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61116 -3 14H3C3 7.92487 7.92487 3 14 3V-3Z"
          fill="#FFD321"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M14 3H34V-3H14V3ZM3 26V14H-3V26H3ZM24 47C12.402 47 3 37.598 3 26H-3C-3 40.9117 9.08831 53 24 53V47ZM45 26C45 37.598 35.598 47 24 47V53C38.9117 53 51 40.9117 51 26H45ZM45 14V26H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61116 -3 14H3C3 7.92487 7.92487 3 14 3V-3Z"
          fill="#FFE16B"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M15.9905 15L12.0068 19.9853H19.9742L15.9905 15Z"
          fill="#FFD321"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M23.9578 15L19.9741 19.9853H27.9393L23.9578 15Z"
          fill="#FFD321"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M31.8895 15L27.9058 19.9853C30.6045 19.9853 33.3011 19.9853 35.9999 19.9853C34.6283 18.3235 33.2589 16.6618 31.8895 15Z"
          fill="#FFD321"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M24 35L36 19.9854C27.9993 19.9854 20.0007 19.9854 12 19.9854C15.9993 24.9902 20.0007 29.9951 24 35Z"
          fill="#FFD321"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M15.9902 15C17.3174 16.6618 18.6468 18.3235 19.9739 19.9853L23.9576 15C21.3011 15 18.6446 15 15.9902 15Z"
          fill="#FFE16B"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M31.8893 15L27.939 19.9853L23.9575 15H31.8893Z"
          fill="#FFE16B"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M19.9741 19.9854L24.0001 35L27.9393 19.9854H19.9741Z"
          fill="#FFE16B"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="50"
        >
          <mask id="path-10-inside-2" mask-type="luminance" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48 14C48 6.26802 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26.9231C0 39.6681 10.7452 50 24 50C37.2548 50 48 39.6681 48 26.9231V14Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 14C48 6.26802 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26.9231C0 39.6681 10.7452 50 24 50C37.2548 50 48 39.6681 48 26.9231V14Z"
            fill="#FFF3E5"
          />
          <path
            d="M14 3H34V-3H14V3ZM3 26.9231V14H-3V26.9231H3ZM24 47C12.29 47 3 37.9014 3 26.9231H-3C-3 41.4348 9.2003 53 24 53V47ZM45 26.9231C45 37.9014 35.71 47 24 47V53C38.7997 53 51 41.4348 51 26.9231H45ZM45 14V26.9231H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61115 -3 14H3C3 7.92486 7.92487 3 14 3V-3Z"
            fill="#EDC474"
            mask="url(#path-10-inside-2)"
          />
        </mask>
        <g mask="url(#mask0)">
          <rect
            opacity="0.2"
            x="-16"
            y="46"
            width="72"
            height="20"
            transform="rotate(-45 -16 48)"
            fill="white"
          />
        </g>
      </svg>
    </span>
  );
};

export default MasterIconSVG;
